import React, { useMemo, useState, forwardRef } from "react";
import DataTable from "react-data-table-component";
import { Col, Dropdown } from "reactstrap";
import { useHistory, Link } from "react-router-dom";
import Swal from "sweetalert2";
import Loader from "../../components/shared/Loader";
import { deleteData, postData } from "./getData";
import { useEffect } from "react";

const Table = props => {
	let navigate = useHistory();

	const [loading, setLoading] = useState(false);
	const [filterText, setFilterText] = useState("");
	const [data, setData] = useState([]);

	const filteredItems = data?.filter(
		item =>
			JSON.stringify(item).toLowerCase().indexOf(filterText.toLowerCase()) !==
			-1
	);

	useEffect(() => {
		setData(props?.data);
	}, [props?.data]);

	const BootyCheckbox = new forwardRef(({ onClick, ...rest }, ref) => (
		<div className="form-check">
			<input
				htmlFor="booty-check"
				type="checkbox"
				className="form-check-input"
				ref={ref}
				onClick={onClick}
				{...rest}
			/>
			<label className="form-check-label" id="booty-check" />
		</div>
	));

	const handleDeleteClick = (slug, name) => {
		Swal.fire({
			text: `تاكيد حذف ( ${name?.ar} )`,
			icon: "question",
			showCancelButton: true,
			confirmButtonText: "حذف",
			confirmButtonColor: "#12c8cb",
			cancelButtonColor: "#fc5296",
			cancelButtonText: "الغاء",
		}).then(result => {
			if (result.isConfirmed) {
				// dispatch(deletecategory(id));
				deleteData({
					url: `/pages/categories/sections/${slug}`,
					setData: () => {
						setData(data?.filter(e => e?.slug !== slug));
					},
					setLoading,
				});
			}
		});
	};

	const columns = [
		{
			name: "الاسم",
			selector: row => row?.name?.ar,
			sortable: true,
		},
		// {
		// 	name: props.categoryType === "sub" && "التصنيف الرئيسي",
		// 	selector: row => props.categoryType === "sub" && row?.category?.name?.ar,
		// 	sortable: true,
		// },
		// {
		// 	name: <FormattedMessage id={"createdAtDate"} />,
		// 	selector: row => {
		// 		return handleIsoDate(row?.createdAt);
		// 	},
		// 	sortable: true,
		// },
		{
			cell: row => (
				<div className="global-dropdown d-flex gap-2">
					{/* <Link to={`/categories/${props.categoryType}/${row?.slug}`}>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="12"
							height="12"
							fill="#fff"
							className="bi bi-pencil edit"
							viewBox="0 0 16 16"
						>
							<path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
						</svg>
						تعديل
					</Link>
					<Link to="#" onClick={() => handleDeleteClick(row?.slug, row?.name)}>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="12"
							height="12"
							fill="#fff"
							className="bi bi-pencil edit"
							viewBox="0 0 16 16"
						>
							<path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
						</svg>
						حذف
					</Link> */}
					<li className="list-inline-item">
						<Link
							className="bt bt-sm bt-success"
							to={`/categories/${props.categoryType}/${row?.slug}`}
						>
							<i className="fas fa-edit"></i>
						</Link>
					</li>
					<li className="list-inline-item">
						<button
							className="bt bt-sm bt-danger"
							onClick={() => handleDeleteClick(row?.slug, row?.name)}
						>
							<i className="fas fa-trash"></i>
						</button>
					</li>
				</div>
			),
			allowOverflow: true,
			button: true,
		},
	];
	if (loading) return <Loader />;

	return (
		<>
			<div className="table-wrap">
				<div className="card">
					<div className="card-body">
						<DataTable
							columns={columns}
							data={filteredItems}
							progressPending={props.loading}
							progressComponent={<Loader />}
							defaultSortField="name"
							selectableRows
							noHeader
							// subHeader
							// subHeaderComponent={subHeaderComponent}
							selectableRowsComponent={BootyCheckbox}
						/>
					</div>
				</div>
			</div>
		</>
	);
};

export default Table;
